import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import { css, cx } from '@emotion/css';
import { theme, setDefault } from '../../styles/theme';
import { deepDefaults, palette, getLeft, darken } from '../../styles/utils';
import '../../styles/global';
import { cache } from '../utils';
export var types = ['primary', 'warning', 'danger', 'active', 'success'];
var sizes = ['large', 'small', 'mini'];
var btnStyles = {
  get color() {
    return theme.color.text;
  },
  bgColor: '#fff',
  lineHeight: '1.15',
  get padding() {
    return "0 16px";
  },
  get borderColor() {
    return theme.color.border;
  },
  get borderRadius() {
    return theme.borderRadius;
  },
  get fontSize() {
    return theme.default.fontSize;
  },
  get height() {
    return theme.default.height;
  },
  get hoverBorderColor() {
    return theme.color.primary;
  },
  get hoverColor() {
    return theme.color.primary;
  },
  // ghost
  ghost: {
    color: '#fff',
    get hoverColor() {
      return palette(theme.color.primary, -1);
    },
    borderColor: '#fff',
    get hoverBorderColor() {
      return palette(theme.color.primary, -1);
    }
  },
  // icon
  icon: {
    gap: '5px',
    fontSize: '16px'
  },
  // disabled
  disabled: {
    get color() {
      return theme.color.disabled;
    },
    get bgColor() {
      return theme.color.disabledBg;
    },
    get borderColor() {
      return theme.color.disabledBorder;
    },
    get ghostBorderColor() {
      return theme.color.disabled;
    }
  }
};
var btnTypeStyles = types.reduce(function (memo, type) {
  if (type !== 'active') {
    // const color = theme.color;
    memo[type] = {
      color: '#fff',
      get bgColor() {
        return theme.color[type];
      },
      get borderColor() {
        return theme.color[type];
      },
      get hoverBorderColor() {
        return palette(theme.color[type], -1);
      },
      get ghostColor() {
        return theme.color[type];
      }
    };
  }
  return memo;
}, {});
var btnActiveStyles = {
  get color() {
    return theme.color.primary;
  },
  get bgColor() {
    return palette(theme.color.primary, -4);
  },
  get borderColor() {
    return btnTypeStyles.primary.borderColor;
  },
  get hoverBorderColor() {
    return btnTypeStyles.primary.hoverBorderColor;
  },
  get ghostColor() {
    return btnTypeStyles.primary.ghostColor;
  }
};
var btnSizeStyles = sizes.reduce(function (memo, size) {
  // const defaultStyle = theme[size];
  memo[size] = {
    get fontSize() {
      return theme[size].fontSize;
    },
    get height() {
      return theme[size].height;
    },
    get padding() {
      return "0 " + theme[size].padding;
    }
  };
  if (size === 'large') {
    Object.defineProperty(memo[size], 'padding', {
      value: "0 24px"
    });
  }
  return memo;
}, {});
var defaults = deepDefaults({
  get transition() {
    return theme.transition.middle;
  },
  active: btnActiveStyles,
  secondary: {
    get color() {
      return theme.color.primary;
    },
    get borderColor() {
      return theme.color.primary;
    },
    get hoverBgColor() {
      return palette(theme.color.primary, -4);
    },
    get activeBgColor() {
      return palette(theme.color.primary, -3);
    }
  },
  link: {
    get color() {
      return theme.color.link;
    },
    get hoverColor() {
      return theme.color.linkHover;
    },
    hoverBgColor: 'transparent'
    // get hoverBgColor() { return theme.color.hoverBg },
  },
  none: {
    get hoverBgColor() {
      return theme.color.bg;
    }
  },
  // ButtonGroup
  group: {
    primary: {
      get borderColor() {
        return darken(button.primary.borderColor, 3);
      }
    },
    warning: {
      get borderColor() {
        return darken(button.warning.borderColor, 3);
      }
    },
    danger: {
      get borderColor() {
        return darken(button.danger.borderColor, 3);
      }
    },
    success: {
      get borderColor() {
        return darken(button.success.borderColor, 3);
      }
    }
  }
}, btnStyles, btnTypeStyles, btnSizeStyles);
var button;
setDefault(function () {
  button = deepDefaults(theme, {
    button: defaults
  }).button;
  makeButtonStyles == null || makeButtonStyles.clearCache();
  makeButtonGroupStyles == null || makeButtonGroupStyles.clearCache();
});
export { button };
export var makeButtonStyles = cache(function makeButtonStyles(k, iconSide) {
  var _button = button,
    secondary = _button.secondary,
    link = _button.link;
  return cx(
  /*#__PURE__*/
  // extract static styles to individual css method for performance
  css("display:inline-flex;align-items:center;justify-content:center;cursor:pointer;height:", button.height, ";padding:", button.padding, ";outline:none;vertical-align:middle;color:", button.color, ";background:", button.bgColor, ";border-radius:", button.borderRadius, ";border:1px solid ", button.borderColor, ";font-size:", button.fontSize, ";white-space:nowrap;transition:all ", button.transition, ";line-height:", button.lineHeight, ";.", k, "-icon{color:inherit;}&.", k, "-default,&.", k, "-none,&.", k, "-flat{.", k, "-icon{color:", theme.color.lightBlack, ";}&:hover{.", k, "-icon{color:inherit;}}}&:hover,&:focus{border-color:", button.hoverBorderColor, ";color:", button.hoverColor, ";}&:active{background:", palette(theme.color.primary, -4), ";}.", k, "-button-input{position:absolute;opacity:0;width:0;height:0;}", _mapInstanceProperty(types).call(types, function (type) {
    var typeStyles = button[type];
    return /*#__PURE__*/css("&.", k, "-", type, "{background:", typeStyles.bgColor, ";color:", typeStyles.color, ";border-color:", typeStyles.borderColor, ";&:hover,&:focus{background:", palette(typeStyles.bgColor, -1), ";border-color:", typeStyles.hoverBorderColor, ";color:", typeStyles.color, ";}&:active{background:", palette(typeStyles.bgColor, 1), ";border-color:", palette(typeStyles.borderColor, 1), ";}}");
  }), "&.", k, "-secondary{color:", secondary.color, ";border-color:", secondary.borderColor, ";&:hover,&:focus{background:", secondary.hoverBgColor, ";}&:active{background:", secondary.activeBgColor, ";}}&.", k, "-link{color:", link.color, ";&:hover{color:", link.hoverColor, ";background:", link.hoverBgColor, ";}}&.", k, "-none,&.", k, "-link,&.", k, "-flat{background:transparent;&,&:hover{border:none;}&.", k, "-active{color:", theme.color.primary, ";}}&.", k, "-none:hover{background:", button.none.hoverBgColor, ";}&.", k, "-flat{background:", button.none.hoverBgColor, ";}&.", k, "-disabled{.", k, "-icon{color:inherit;}&,&:hover{color:", button.disabled.color, ";background:", button.disabled.bgColor, ";border-color:", button.disabled.borderColor, ";cursor:not-allowed;}}&.", k, "-none.", k, "-disabled,&.", k, "-link.", k, "-disabled{&,&:hover{background:transparent;}}", _mapInstanceProperty(sizes).call(sizes, function (size) {
    var styles = button[size];
    return /*#__PURE__*/css("&.", k, "-", size, "{font-size:", styles.fontSize, ";height:", styles.height, ";padding:", styles.padding, ";&.", k, "-btn-icon{width:", styles.height, ";}}");
  }), "&.", k, "-btn-icon{width:", button.height, ";padding:0;.", k, "-icon{margin:0;}}&.", k, "-fluid{width:100%;padding:0;}&.", k, "-circle{border-radius:calc(", button.large.height, " / 2);}&.", k, "-loading{", _mapInstanceProperty(types).call(types, function (type) {
    var styles = button[type];
    return /*#__PURE__*/css("&.", k, "-", type, "{&,&:hover{background:", palette(styles.bgColor, -2), ";color:", palette(styles.color, -2), ";border-color:", palette(styles.borderColor, -2), ";}}");
  }), ";&,&:hover{background:", palette(button.bgColor, -2), ";color:", palette(button.color, -2), ";border-color:", palette(button.borderColor, -2), ";}.", k, "-icon:not(.", k, "-icon-loading){display:none;}}&:not(button){display:inline-flex;align-items:center;justify-content:center;}&.", k, "-ghost{background:transparent;color:", button.ghost.color, ";border-color:", button.ghost.borderColor, ";.", k, "-icon{color:inherit;}&:hover,&:active{background:transparent;}&:hover{color:", button.ghost.hoverColor, ";border-color:", button.ghost.hoverBorderColor, ";}&:active{color:", theme.color.primary, ";border-color:", theme.color.primary, ";}", _mapInstanceProperty(types).call(types, function (type) {
    var _button$type = button[type],
      ghostColor = _button$type.ghostColor,
      borderColor = _button$type.borderColor;
    return /*#__PURE__*/css("&.", k, "-", type, "{color:", ghostColor, ";border-color:", borderColor, ";&:hover{color:", palette(ghostColor, -1), ";border-color:", palette(ghostColor, -1), ";}&:active{color:", palette(ghostColor, 1), ";border-color:", palette(ghostColor, 1), ";}}");
  }), "&.", k, "-disabled{&,&:hover{color:", button.disabled.color, ";border-color:", button.disabled.ghostBorderColor, ";background:transparent;}}}"),
  /*#__PURE__*/
  // dynamic styles
  css(".", k, "-icon{", iconSide === 'right' ? "margin-left: " + button.icon.gap + ";" : "margin-right: " + button.icon.gap + ";", ";}", !iconSide && /*#__PURE__*/css("&.", k, "-loading{&:not(.", k, "-btn-icon){padding-left:calc(", getLeft(button.padding), " + 1em);", _mapInstanceProperty(sizes).call(sizes, function (size) {
    return /*#__PURE__*/css("&.", k, "-", size, "{padding-left:calc(", getLeft(button[size].padding), " + 1em);}");
  }), ";.", k, "-icon-loading{margin-left:-1em;}}}"), ";"));
});
export var makeButtonGroupStyles = cache(function makeButtonGroupStyles(k) {
  return /*#__PURE__*/css("display:inline-flex;align-items:center;flex-wrap:wrap;vertical-align:middle;.", k, "-btn{margin:0;vertical-align:middle;&:hover,&:focus,&.", k, "-active{z-index:1;position:relative;}}&.", k, "-fluid{width:100%;}&:not(.", k, "-vertical):not(.", k, "-seperate){>.", k, "-btn{", _mapInstanceProperty(types).call(types, function (type) {
    if (type === 'active') return;
    var borderColor = button.group[type].borderColor;
    return /*#__PURE__*/css("&.", k, "-", type, ":not(:first-child){border-left-color:", borderColor, ";}&.", k, "-", type, ":not(:last-child){border-right-color:", borderColor, ";}");
  }), ";&:not(:first-child){margin-left:-1px;&:not(:last-child){border-radius:0;}}&:not(:only-child):first-child{border-top-right-radius:0;border-bottom-right-radius:0;}&:not(:only-child):last-child{border-top-left-radius:0;border-bottom-left-radius:0;}}&.", k, "-fluid{display:flex;>.", k, "-btn{flex:1;}}}&.", k, "-vertical:not(.", k, "-seperate){flex-direction:column;>.", k, "-btn{", _mapInstanceProperty(types).call(types, function (type) {
    if (type === 'active') return;
    var borderColor = button.group[type].borderColor;
    return /*#__PURE__*/css("&.", k, "-", type, ":not(:first-child){border-top-color:", borderColor, ";}&.", k, "-", type, ":not(:last-child){border-bottom-color:", borderColor, ";}");
  }), ";&:not(.", k, "-btn-icon){width:100%;}&:not(:first-child){margin-top:-1px;&:not(:last-child){border-radius:0;}}&:not(:only-child):first-child{border-bottom-left-radius:0;border-bottom-right-radius:0;}&:not(:only-child):last-child{border-top-left-radius:0;border-top-right-radius:0;}}}&.", k, "-seperate{gap:8px;}");
});